import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const badges = [{
  emoji: '📄',
  label: 'Ebook + Discord + 3 Bonos'
}, {
  emoji: '⚡',
  label: 'Acceso inmediato'
}, {
  emoji: '🇦🇷',
  label: 'Pensado para Argentina'
}, {
  emoji: '📈',
  label: 'Método, no señales'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden border-b border-white/5 bg-ink-950 bg-grid px-5 pb-16 pt-16 sm:pb-20 sm:pt-20 lg:pt-24" data-id="element-101" data-mp="128fqzmni4jxa">
      {/* soft brand glow, kept subtle */}
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-brand/10 blur-[120px]" data-id="element-102" data-mp="sai4b3laiv6s" />

      <div className="relative mx-auto flex w-full max-w-4xl flex-col items-center text-center" data-id="element-103" data-mp="3d1aafpn8alfx">
        <motion.span initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mb-6 inline-flex items-center gap-2 rounded-full border border-brand/30 bg-brand-soft px-3.5 py-1.5 text-xs font-medium text-brand" data-id="element-104" data-mp="382p5jcx17dl5">
          <span className="h-1.5 w-1.5 rounded-full bg-brand" data-id="element-105" data-mp="39aur5dd7zmx8" />
          CAPITAL CONSCIENTE
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.05
      }} className="font-display text-3xl font-extrabold leading-[1.1] tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-106" data-mp="3e8egp9fdbm4h">
          Todo lo que enseña una mentoría de trading de{' '}
          <span className="text-brand" data-id="element-107" data-mp="2qi0mbc9b9b6q">$500 USD</span>, sin pagar $500 USD
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.12
      }} className="mt-6 max-w-2xl text-base leading-relaxed text-gray-400 sm:text-lg" data-id="element-108" data-mp="2vglmjbokbuv6">
          Aprendé a operar con método — estrategias, backtesting y comunidad — al
          alcance de quien recién arranca. No es de un día para el otro. Es un
          camino real, con las herramientas para empezarlo bien.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.18
      }} className="mt-7 w-full" data-id="element-109" data-mp="i9vrh5f8g2md">
          <img src="https://cdn.magicpatterns.com/uploads/qdrJPhxYYjJRqNAdaa4EiY/1-removebg-preview_(2).png" alt="Mockup de Capital Consciente con ebook, Discord y bonos" className="mx-auto h-auto w-full max-w-md object-contain" data-id="element-110" data-mp="1ayjgnc33rc57" />
        </motion.div>

        <motion.ul initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.24
      }} className="mt-8 flex flex-wrap items-center justify-center gap-2" data-id="element-111" data-mp="x3h1rzga2cg9">
          {badges.map(b => <li key={b.label} className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-ink-850 px-3.5 py-1.5 text-xs font-medium text-gray-300 sm:text-sm" data-id="element-112" data-mp="1xb5qyhfqoxhp">
              <span aria-hidden="true" data-id="element-113" data-mp="26868q58azxc6">{b.emoji}</span>
              {b.label}
            </li>)}
        </motion.ul>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.24
      }} className="mt-10 flex w-full flex-col items-center" data-id="element-114" data-mp="2g0c29je7emth">
          <CtaButton size="lg" className="w-full max-w-md" data-id="element-115" data-mp="2p1sapllgkev2">
            SI, QUIERO MANEJAR MI CAPITAL CONSCIENTE
          </CtaButton>

          <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-gray-500 sm:text-sm" data-id="element-116" data-mp="2tx7lu5s2zwns">
            <span className="inline-flex items-center gap-1.5" data-id="element-117" data-mp="zl0zcatqltg6">
              <ShieldCheckIcon className="h-4 w-4 text-brand" data-id="element-118" data-mp="znn8gewa0h0i" /> Garantía 30 días
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-119" data-mp="4dgwysp2bj72">
              <LockIcon className="h-4 w-4 text-brand" data-id="element-120" data-mp="3vgvt2gjt4v0g" /> Pago seguro
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-121" data-mp="e8imhpn92na6">
              <CreditCardIcon className="h-4 w-4 text-brand" data-id="element-122" data-mp="9ah2n2i02jxn" /> Mercado Pago
            </span>
          </div>

          <div className="mt-8 inline-flex items-center gap-2 rounded-full border border-white/10 bg-ink-900 px-4 py-2 text-xs text-gray-400 sm:text-sm" data-id="element-123" data-mp="3hq0qtn3tdc5u">
            <span className="relative flex h-2 w-2" data-id="element-124" data-mp="3ct0lxfipafgb">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand opacity-60" data-id="element-125" data-mp="3rgllx0ka3yk0" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-brand" data-id="element-126" data-mp="3moc2m3do5wqp" />
            </span>
            209 personas se unieron al Discord en los últimos 5 días
          </div>
        </motion.div>
      </div>
    </header>;
}